import { Injectable } from "@angular/core";
import { DateRange } from "../../../../../../shared/services/date.service";
import { GooglePerformanceMax } from "../../../domain/models/google-performance-max";
import { RecommendedSchedule } from "../../../domain/models/publication-template";
import { PublicationEventInput } from "../calendar-event-publication/publication-event-input";
import {
  IPublicationTemplateCalendarEventFactory,
  mapPublicationTemplateToCalendarEvents,
  SocialMediaBorderColor,
  SocialMediaColor,
} from "./calendar-event.mappers";
import "../../../../../../shared/extensions/date.extensions";

export const mapGooglePublicationToCalendarEvent = (
  publication: GooglePerformanceMax, // | ResponsiveAd ...,
  schedule: RecommendedSchedule,
): PublicationEventInput => {
  const baseConfig = mapPublicationTemplateToCalendarEvents(
    publication,
    schedule,
  );
  return {
    ...baseConfig,
    durationEditable: true,
    startEditable: true,
    backgroundColor: SocialMediaColor.Google,
    borderColor: SocialMediaBorderColor.Google,
    extendedProps: {
      ...baseConfig.extendedProps,
      icon: "ic_googleads.svg",
    },
  };
};

@Injectable()
export class GooglePerformanceMaxCalendarEventFactory
  implements IPublicationTemplateCalendarEventFactory
{
  public create(
    publication: GooglePerformanceMax,
    campaignDateRange: DateRange,
  ): PublicationEventInput[] {
    return publication.recommendedSchedules.map((schedule) => {
      const eventConfig = mapGooglePublicationToCalendarEvent(
        publication,
        schedule,
      );

      return {
        ...eventConfig,
        extendedProps: {
          ...eventConfig.extendedProps,
          image: publication.images[0].thumbnailLink,
          title:
            "publicationTemplate.thumbnail.googlePerformanceMaxAd.calendar",
        },
        editable:
          schedule.startDate.isInDayRange(campaignDateRange) &&
          schedule.startDate.isTodayOrFutureDay(),
      };
    });
  }
}
